// This file is auto-generated by @hey-api/openapi-ts

import { type Options, loginUser, logoutUser, requestPasswordReset, resetPassword, activateAccount, refreshAccessToken, verifyEmail, verifySmsCode, sendOnboardingEmail, resendOnboardingEmail, resendEmailVerification, resendSmsVerification, getSchoolInfo, listPublicPackages, getPackageAgreement, registerUser, getGeneralStudentAgreement, updateGeneralStudentAgreement, getIssuedFormByToken, getUser, listUserActivity, updateUserStatus, getInstructorById, listInstructors, listStudents, getStudent, updateStudent, listStudentCourseEnrollments, listSelfSchedulePeriods, countSelfSchedulePeriods, getStudentSelfScheduleEligibility, getStudentLedger, getStudentSchedule, updateStudentPermit, listStudentIssuedForms, searchStudents, listPackages, getPackage, updatePackage, updatePackageAgreement, listCourses, getCourse, getCoursePolicy, updateCoursePolicy, getSelfScheduleCriteria, updateSelfScheduleCriteria, getCourseEnrollmentCriteria, updateCourseEnrollmentCriteria, getCourseCompletionCriteria, updateCourseCompletionCriteria, updateCourseAgreement, updatePeriodEnrollment, updatePeriodEnrollmentPrivateNotes, listCourseSections, getCourseSection, listSectionEnrollments, listSectionPeriods, getCourseInstructorPool, takeAttendance, searchSectionEnrollments, enrollStudentInSection, getCourseEnrollment, updateEnrollmentCompletionDate, getCoursePeriod, updateCoursePeriod, listPeriodEnrollments, listCourseEnrollmentPeriods, cancelPeriodEnrollment, deleteCoursePeriods, listCoursePeriods, createCoursePeriods, enrollStudentInPeriod, enrollStudentInPeriodWaitlist, deletePeriodEnrollment, listFormTemplates, getFormTemplate, issueForm, issueIndianaEnrollmentCertificationForm, issueIndianaCompletionPermitForm, getIssuedForm, getIssuedFormLink, emailIssuedForm, getCalendarFeed, deleteCharge, listCharges, createCharge, getCharge, updateCharge, voidCharge, listPayments, createPayment, getPayment, updatePayment, voidPayment, listDiscounts, listPaymentMethods, listRefunds, createRefund, getRefund, updateRefund, voidRefund, getTemplate, updateTemplate, listReports, getReport, generateReport, getMyLearningCourses, listCurricula, createCurriculum, getCurriculum, updateCurriculum, publishCurriculum, getCourseCurriculumAssignment, assignCurriculumToCourse, getLearningCourse, updateLearningProgress, submitLearningQuiz } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, infiniteQueryOptions, type InfiniteData, type DefaultError } from '@tanstack/react-query';
import type { LoginUserData, LoginUserError, LoginUserResponse, LogoutUserData, RequestPasswordResetData, RequestPasswordResetError, RequestPasswordResetResponse, ResetPasswordData, ResetPasswordError, ResetPasswordResponse, ActivateAccountData, ActivateAccountError, ActivateAccountResponse, RefreshAccessTokenData, VerifyEmailData, VerifyEmailError, VerifyEmailResponse2, VerifySmsCodeData, VerifySmsCodeError, VerifySmsCodeResponse, SendOnboardingEmailData, SendOnboardingEmailError, SendOnboardingEmailResponse, ResendOnboardingEmailData, ResendOnboardingEmailError, ResendOnboardingEmailResponse, ResendEmailVerificationData, ResendEmailVerificationError, ResendEmailVerificationResponse, ResendSmsVerificationData, ResendSmsVerificationError, ResendSmsVerificationResponse, GetSchoolInfoData, ListPublicPackagesData, GetPackageAgreementData, RegisterUserData, RegisterUserError, RegisterUserResponse, GetGeneralStudentAgreementData, UpdateGeneralStudentAgreementData, UpdateGeneralStudentAgreementError, UpdateGeneralStudentAgreementResponse, GetIssuedFormByTokenData, GetUserData, ListUserActivityData, ListUserActivityError, ListUserActivityResponse, UpdateUserStatusData, UpdateUserStatusError, UpdateUserStatusResponse, GetInstructorByIdData, ListInstructorsData, ListStudentsData, GetStudentData, UpdateStudentData, UpdateStudentError, UpdateStudentResponse, ListStudentCourseEnrollmentsData, ListSelfSchedulePeriodsData, ListSelfSchedulePeriodsError, ListSelfSchedulePeriodsResponse, CountSelfSchedulePeriodsData, CountSelfSchedulePeriodsError, CountSelfSchedulePeriodsResponse, GetStudentSelfScheduleEligibilityData, GetStudentLedgerData, GetStudentScheduleData, UpdateStudentPermitData, UpdateStudentPermitError, UpdateStudentPermitResponse, ListStudentIssuedFormsData, ListStudentIssuedFormsError, ListStudentIssuedFormsResponse, SearchStudentsData, SearchStudentsError, SearchStudentsResponse, ListPackagesData, GetPackageData, UpdatePackageData, UpdatePackageError, UpdatePackageResponse, UpdatePackageAgreementData, UpdatePackageAgreementError, UpdatePackageAgreementResponse, ListCoursesData, GetCourseData, GetCoursePolicyData, UpdateCoursePolicyData, UpdateCoursePolicyError, UpdateCoursePolicyResponse, GetSelfScheduleCriteriaData, UpdateSelfScheduleCriteriaData, UpdateSelfScheduleCriteriaError, UpdateSelfScheduleCriteriaResponse, GetCourseEnrollmentCriteriaData, UpdateCourseEnrollmentCriteriaData, UpdateCourseEnrollmentCriteriaError, UpdateCourseEnrollmentCriteriaResponse, GetCourseCompletionCriteriaData, UpdateCourseCompletionCriteriaData, UpdateCourseCompletionCriteriaError, UpdateCourseCompletionCriteriaResponse, UpdateCourseAgreementData, UpdateCourseAgreementError, UpdateCourseAgreementResponse, UpdatePeriodEnrollmentData, UpdatePeriodEnrollmentError, UpdatePeriodEnrollmentResponse, UpdatePeriodEnrollmentPrivateNotesData, UpdatePeriodEnrollmentPrivateNotesError, UpdatePeriodEnrollmentPrivateNotesResponse, ListCourseSectionsData, ListCourseSectionsError, ListCourseSectionsResponse, GetCourseSectionData, ListSectionEnrollmentsData, ListSectionEnrollmentsError, ListSectionEnrollmentsResponse, ListSectionPeriodsData, ListSectionPeriodsError, ListSectionPeriodsResponse, GetCourseInstructorPoolData, GetCourseInstructorPoolError, GetCourseInstructorPoolResponse, TakeAttendanceData, TakeAttendanceError, TakeAttendanceResponse, SearchSectionEnrollmentsData, SearchSectionEnrollmentsError, SearchSectionEnrollmentsResponse, EnrollStudentInSectionData, EnrollStudentInSectionError, EnrollStudentInSectionResponse, GetCourseEnrollmentData, UpdateEnrollmentCompletionDateData, UpdateEnrollmentCompletionDateError, UpdateEnrollmentCompletionDateResponse, GetCoursePeriodData, UpdateCoursePeriodData, UpdateCoursePeriodError, UpdateCoursePeriodResponse, ListPeriodEnrollmentsData, ListCourseEnrollmentPeriodsData, CancelPeriodEnrollmentData, CancelPeriodEnrollmentError, CancelPeriodEnrollmentResponse, DeleteCoursePeriodsData, DeleteCoursePeriodsError, DeleteCoursePeriodsResponse, ListCoursePeriodsData, ListCoursePeriodsError, ListCoursePeriodsResponse, CreateCoursePeriodsData, CreateCoursePeriodsError, CreateCoursePeriodsResponse, EnrollStudentInPeriodData, EnrollStudentInPeriodError, EnrollStudentInPeriodResponse, EnrollStudentInPeriodWaitlistData, EnrollStudentInPeriodWaitlistError, EnrollStudentInPeriodWaitlistResponse, DeletePeriodEnrollmentData, DeletePeriodEnrollmentError, DeletePeriodEnrollmentResponse, ListFormTemplatesData, GetFormTemplateData, IssueFormData, IssueFormError, IssueFormResponse, IssueIndianaEnrollmentCertificationFormData, IssueIndianaEnrollmentCertificationFormError, IssueIndianaEnrollmentCertificationFormResponse, IssueIndianaCompletionPermitFormData, IssueIndianaCompletionPermitFormError, IssueIndianaCompletionPermitFormResponse, GetIssuedFormData, GetIssuedFormLinkData, EmailIssuedFormData, EmailIssuedFormError, EmailIssuedFormResponse, GetCalendarFeedData, DeleteChargeData, DeleteChargeError, DeleteChargeResponse, ListChargesData, CreateChargeData, CreateChargeError, CreateChargeResponse, GetChargeData, UpdateChargeData, UpdateChargeError, UpdateChargeResponse, VoidChargeData, VoidChargeError, VoidChargeResponse, ListPaymentsData, CreatePaymentData, CreatePaymentError, CreatePaymentResponse, GetPaymentData, UpdatePaymentData, UpdatePaymentError, UpdatePaymentResponse, VoidPaymentData, VoidPaymentError, VoidPaymentResponse, ListDiscountsData, ListPaymentMethodsData, ListRefundsData, CreateRefundData, CreateRefundError, CreateRefundResponse, GetRefundData, UpdateRefundData, UpdateRefundError, UpdateRefundResponse, VoidRefundData, VoidRefundError, VoidRefundResponse, GetTemplateData, UpdateTemplateData, UpdateTemplateError, UpdateTemplateResponse, ListReportsData, GetReportData, GenerateReportData, GenerateReportError, GenerateReportResponse, GetMyLearningCoursesData, ListCurriculaData, CreateCurriculumData, CreateCurriculumError, CreateCurriculumResponse, GetCurriculumData, UpdateCurriculumData, UpdateCurriculumError, UpdateCurriculumResponse, PublishCurriculumData, PublishCurriculumError, PublishCurriculumResponse, GetCourseCurriculumAssignmentData, AssignCurriculumToCourseData, AssignCurriculumToCourseResponse, GetLearningCourseData, UpdateLearningProgressData, UpdateLearningProgressResponse, SubmitLearningQuizData, SubmitLearningQuizResponse } from '../types.gen';
import type { AxiosError } from 'axios';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? _heyApiClient).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const loginUserQueryKey = (options: Options<LoginUserData>) => createQueryKey('loginUser', options);

/**
 * User login
 * Authenticate a user with username and password
 */
export const loginUserOptions = (options: Options<LoginUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await loginUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: loginUserQueryKey(options)
    });
};

/**
 * User login
 * Authenticate a user with username and password
 */
export const loginUserMutation = (options?: Partial<Options<LoginUserData>>): UseMutationOptions<LoginUserResponse, AxiosError<LoginUserError>, Options<LoginUserData>> => {
    const mutationOptions: UseMutationOptions<LoginUserResponse, AxiosError<LoginUserError>, Options<LoginUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await loginUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const logoutUserQueryKey = (options?: Options<LogoutUserData>) => createQueryKey('logoutUser', options);

/**
 * Logout
 * Logout
 */
export const logoutUserOptions = (options?: Options<LogoutUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await logoutUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: logoutUserQueryKey(options)
    });
};

export const requestPasswordResetQueryKey = (options: Options<RequestPasswordResetData>) => createQueryKey('requestPasswordReset', options);

/**
 * Request a password reset link
 * Send user a password reset link
 */
export const requestPasswordResetOptions = (options: Options<RequestPasswordResetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await requestPasswordReset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: requestPasswordResetQueryKey(options)
    });
};

/**
 * Request a password reset link
 * Send user a password reset link
 */
export const requestPasswordResetMutation = (options?: Partial<Options<RequestPasswordResetData>>): UseMutationOptions<RequestPasswordResetResponse, AxiosError<RequestPasswordResetError>, Options<RequestPasswordResetData>> => {
    const mutationOptions: UseMutationOptions<RequestPasswordResetResponse, AxiosError<RequestPasswordResetError>, Options<RequestPasswordResetData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await requestPasswordReset({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resetPasswordQueryKey = (options: Options<ResetPasswordData>) => createQueryKey('resetPassword', options);

/**
 * User password reset
 * Resets a users password
 */
export const resetPasswordOptions = (options: Options<ResetPasswordData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resetPassword({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resetPasswordQueryKey(options)
    });
};

/**
 * User password reset
 * Resets a users password
 */
export const resetPasswordMutation = (options?: Partial<Options<ResetPasswordData>>): UseMutationOptions<ResetPasswordResponse, AxiosError<ResetPasswordError>, Options<ResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<ResetPasswordResponse, AxiosError<ResetPasswordError>, Options<ResetPasswordData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resetPassword({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const activateAccountQueryKey = (options: Options<ActivateAccountData>) => createQueryKey('activateAccount', options);

/**
 * Activate imported user account
 * Activates an imported user account by setting their password
 */
export const activateAccountOptions = (options: Options<ActivateAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await activateAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: activateAccountQueryKey(options)
    });
};

/**
 * Activate imported user account
 * Activates an imported user account by setting their password
 */
export const activateAccountMutation = (options?: Partial<Options<ActivateAccountData>>): UseMutationOptions<ActivateAccountResponse, AxiosError<ActivateAccountError>, Options<ActivateAccountData>> => {
    const mutationOptions: UseMutationOptions<ActivateAccountResponse, AxiosError<ActivateAccountError>, Options<ActivateAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await activateAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const refreshAccessTokenQueryKey = (options?: Options<RefreshAccessTokenData>) => createQueryKey('refreshAccessToken', options);

/**
 * Request new access token
 * Use refresh token to get a new access token
 */
export const refreshAccessTokenOptions = (options?: Options<RefreshAccessTokenData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await refreshAccessToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: refreshAccessTokenQueryKey(options)
    });
};

export const verifyEmailQueryKey = (options: Options<VerifyEmailData>) => createQueryKey('verifyEmail', options);

/**
 * Verify a user's email using a token
 * Marks a user's or parent's email as verified using a JWT token.
 *
 */
export const verifyEmailOptions = (options: Options<VerifyEmailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await verifyEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: verifyEmailQueryKey(options)
    });
};

/**
 * Verify a user's email using a token
 * Marks a user's or parent's email as verified using a JWT token.
 *
 */
export const verifyEmailMutation = (options?: Partial<Options<VerifyEmailData>>): UseMutationOptions<VerifyEmailResponse2, AxiosError<VerifyEmailError>, Options<VerifyEmailData>> => {
    const mutationOptions: UseMutationOptions<VerifyEmailResponse2, AxiosError<VerifyEmailError>, Options<VerifyEmailData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await verifyEmail({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const verifySmsCodeQueryKey = (options: Options<VerifySmsCodeData>) => createQueryKey('verifySmsCode', options);

/**
 * Verify a user's phone number using an OTP code
 * Marks a user's or parent's phone number as verified using a one-time password (OTP) code. Requires authentication.
 *
 */
export const verifySmsCodeOptions = (options: Options<VerifySmsCodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await verifySmsCode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: verifySmsCodeQueryKey(options)
    });
};

/**
 * Verify a user's phone number using an OTP code
 * Marks a user's or parent's phone number as verified using a one-time password (OTP) code. Requires authentication.
 *
 */
export const verifySmsCodeMutation = (options?: Partial<Options<VerifySmsCodeData>>): UseMutationOptions<VerifySmsCodeResponse, AxiosError<VerifySmsCodeError>, Options<VerifySmsCodeData>> => {
    const mutationOptions: UseMutationOptions<VerifySmsCodeResponse, AxiosError<VerifySmsCodeError>, Options<VerifySmsCodeData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await verifySmsCode({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sendOnboardingEmailQueryKey = (options: Options<SendOnboardingEmailData>) => createQueryKey('sendOnboardingEmail', options);

/**
 * Send onboarding email to imported user
 * Sends onboarding email to a user without a password (admin/instructor only)
 */
export const sendOnboardingEmailOptions = (options: Options<SendOnboardingEmailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await sendOnboardingEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sendOnboardingEmailQueryKey(options)
    });
};

/**
 * Send onboarding email to imported user
 * Sends onboarding email to a user without a password (admin/instructor only)
 */
export const sendOnboardingEmailMutation = (options?: Partial<Options<SendOnboardingEmailData>>): UseMutationOptions<SendOnboardingEmailResponse, AxiosError<SendOnboardingEmailError>, Options<SendOnboardingEmailData>> => {
    const mutationOptions: UseMutationOptions<SendOnboardingEmailResponse, AxiosError<SendOnboardingEmailError>, Options<SendOnboardingEmailData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await sendOnboardingEmail({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resendOnboardingEmailQueryKey = (options: Options<ResendOnboardingEmailData>) => createQueryKey('resendOnboardingEmail', options);

/**
 * Resend user onboarding email (activation link)
 * Resends the user's onboarding email with activation link (admin/instructor only).
 *
 * **IMPORTANT:** This endpoint ONLY resends the user's onboarding email.
 * For parent email verification resends, use `POST /public/auth/email/resend` instead.
 *
 * The user must have a pending onboarding request (not yet activated).
 *
 */
export const resendOnboardingEmailOptions = (options: Options<ResendOnboardingEmailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resendOnboardingEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resendOnboardingEmailQueryKey(options)
    });
};

/**
 * Resend user onboarding email (activation link)
 * Resends the user's onboarding email with activation link (admin/instructor only).
 *
 * **IMPORTANT:** This endpoint ONLY resends the user's onboarding email.
 * For parent email verification resends, use `POST /public/auth/email/resend` instead.
 *
 * The user must have a pending onboarding request (not yet activated).
 *
 */
export const resendOnboardingEmailMutation = (options?: Partial<Options<ResendOnboardingEmailData>>): UseMutationOptions<ResendOnboardingEmailResponse, AxiosError<ResendOnboardingEmailError>, Options<ResendOnboardingEmailData>> => {
    const mutationOptions: UseMutationOptions<ResendOnboardingEmailResponse, AxiosError<ResendOnboardingEmailError>, Options<ResendOnboardingEmailData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resendOnboardingEmail({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resendEmailVerificationQueryKey = (options: Options<ResendEmailVerificationData>) => createQueryKey('resendEmailVerification', options);

/**
 * Resend email verification
 * Resends an email verification message. Finds the most recent pending verification request for the email address and generates a new JWT token.
 *
 */
export const resendEmailVerificationOptions = (options: Options<ResendEmailVerificationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resendEmailVerification({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resendEmailVerificationQueryKey(options)
    });
};

/**
 * Resend email verification
 * Resends an email verification message. Finds the most recent pending verification request for the email address and generates a new JWT token.
 *
 */
export const resendEmailVerificationMutation = (options?: Partial<Options<ResendEmailVerificationData>>): UseMutationOptions<ResendEmailVerificationResponse, AxiosError<ResendEmailVerificationError>, Options<ResendEmailVerificationData>> => {
    const mutationOptions: UseMutationOptions<ResendEmailVerificationResponse, AxiosError<ResendEmailVerificationError>, Options<ResendEmailVerificationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resendEmailVerification({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resendSmsVerificationQueryKey = (options: Options<ResendSmsVerificationData>) => createQueryKey('resendSmsVerification', options);

/**
 * Resend SMS verification (authenticated)
 * Resends an SMS verification message. Requires authentication and uses the authenticated user's ID to scope the verification request.
 *
 */
export const resendSmsVerificationOptions = (options: Options<ResendSmsVerificationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resendSmsVerification({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resendSmsVerificationQueryKey(options)
    });
};

/**
 * Resend SMS verification (authenticated)
 * Resends an SMS verification message. Requires authentication and uses the authenticated user's ID to scope the verification request.
 *
 */
export const resendSmsVerificationMutation = (options?: Partial<Options<ResendSmsVerificationData>>): UseMutationOptions<ResendSmsVerificationResponse, AxiosError<ResendSmsVerificationError>, Options<ResendSmsVerificationData>> => {
    const mutationOptions: UseMutationOptions<ResendSmsVerificationResponse, AxiosError<ResendSmsVerificationError>, Options<ResendSmsVerificationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resendSmsVerification({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSchoolInfoQueryKey = (options?: Options<GetSchoolInfoData>) => createQueryKey('getSchoolInfo', options);

/**
 * Get School Info
 */
export const getSchoolInfoOptions = (options?: Options<GetSchoolInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSchoolInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSchoolInfoQueryKey(options)
    });
};

export const listPublicPackagesQueryKey = (options?: Options<ListPublicPackagesData>) => createQueryKey('listPublicPackages', options);

/**
 * Get Packages
 */
export const listPublicPackagesOptions = (options?: Options<ListPublicPackagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPublicPackages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPublicPackagesQueryKey(options)
    });
};

export const getPackageAgreementQueryKey = (options: Options<GetPackageAgreementData>) => createQueryKey('getPackageAgreement', options);

/**
 * Get combined agreement for a package
 * Returns the agreement HTML for the package, along with a SHA256 hash.
 */
export const getPackageAgreementOptions = (options: Options<GetPackageAgreementData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPackageAgreement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPackageAgreementQueryKey(options)
    });
};

export const registerUserQueryKey = (options: Options<RegisterUserData>) => createQueryKey('registerUser', options);

/**
 * Register a user
 */
export const registerUserOptions = (options: Options<RegisterUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await registerUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: registerUserQueryKey(options)
    });
};

/**
 * Register a user
 */
export const registerUserMutation = (options?: Partial<Options<RegisterUserData>>): UseMutationOptions<RegisterUserResponse, AxiosError<RegisterUserError>, Options<RegisterUserData>> => {
    const mutationOptions: UseMutationOptions<RegisterUserResponse, AxiosError<RegisterUserError>, Options<RegisterUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await registerUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGeneralStudentAgreementQueryKey = (options: Options<GetGeneralStudentAgreementData>) => createQueryKey('getGeneralStudentAgreement', options);

/**
 * Get the general student agreement for a tenant
 * Retrieves the general student agreement for the specified tenant, including the latest version.
 */
export const getGeneralStudentAgreementOptions = (options: Options<GetGeneralStudentAgreementData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGeneralStudentAgreement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGeneralStudentAgreementQueryKey(options)
    });
};

/**
 * Update the general student agreement for a tenant
 * Creates a new version of the tenant's general student agreement, or creates a new agreement if none exists. This is specific to the tenant’s "general student agreement".
 */
export const updateGeneralStudentAgreementMutation = (options?: Partial<Options<UpdateGeneralStudentAgreementData>>): UseMutationOptions<UpdateGeneralStudentAgreementResponse, AxiosError<UpdateGeneralStudentAgreementError>, Options<UpdateGeneralStudentAgreementData>> => {
    const mutationOptions: UseMutationOptions<UpdateGeneralStudentAgreementResponse, AxiosError<UpdateGeneralStudentAgreementError>, Options<UpdateGeneralStudentAgreementData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateGeneralStudentAgreement({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIssuedFormByTokenQueryKey = (options: Options<GetIssuedFormByTokenData>) => createQueryKey('getIssuedFormByToken', options);

/**
 * Retrieve an issued form using an access token
 * Retrieves the document associated with the provided JWT access token.
 * The token must be provided as a query parameter.
 *
 */
export const getIssuedFormByTokenOptions = (options: Options<GetIssuedFormByTokenData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getIssuedFormByToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getIssuedFormByTokenQueryKey(options)
    });
};

export const getUserQueryKey = (options: Options<GetUserData>) => createQueryKey('getUser', options);

/**
 * Fetch User By Id
 */
export const getUserOptions = (options: Options<GetUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserQueryKey(options)
    });
};

export const listUserActivityQueryKey = (options: Options<ListUserActivityData>) => createQueryKey('listUserActivity', options);

/**
 * Get user activity
 * Retrieve a list of activities for a specific user by their ID.
 */
export const listUserActivityOptions = (options: Options<ListUserActivityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listUserActivity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUserActivityQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listUserActivityInfiniteQueryKey = (options: Options<ListUserActivityData>): QueryKey<Options<ListUserActivityData>> => createQueryKey('listUserActivity', options, true);

/**
 * Get user activity
 * Retrieve a list of activities for a specific user by their ID.
 */
export const listUserActivityInfiniteOptions = (options: Options<ListUserActivityData>) => {
    return infiniteQueryOptions<ListUserActivityResponse, AxiosError<ListUserActivityError>, InfiniteData<ListUserActivityResponse>, QueryKey<Options<ListUserActivityData>>, number | Pick<QueryKey<Options<ListUserActivityData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListUserActivityData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listUserActivity({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUserActivityInfiniteQueryKey(options)
    });
};

/**
 * Update user active status
 * Marks a user as active or inactive
 */
export const updateUserStatusMutation = (options?: Partial<Options<UpdateUserStatusData>>): UseMutationOptions<UpdateUserStatusResponse, AxiosError<UpdateUserStatusError>, Options<UpdateUserStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserStatusResponse, AxiosError<UpdateUserStatusError>, Options<UpdateUserStatusData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateUserStatus({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInstructorByIdQueryKey = (options: Options<GetInstructorByIdData>) => createQueryKey('getInstructorById', options);

/**
 * Fetch Instructor By Id
 */
export const getInstructorByIdOptions = (options: Options<GetInstructorByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInstructorById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getInstructorByIdQueryKey(options)
    });
};

export const listInstructorsQueryKey = (options: Options<ListInstructorsData>) => createQueryKey('listInstructors', options);

/**
 * Fetch Instructors
 */
export const listInstructorsOptions = (options: Options<ListInstructorsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listInstructors({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listInstructorsQueryKey(options)
    });
};

export const listStudentsQueryKey = (options: Options<ListStudentsData>) => createQueryKey('listStudents', options);

/**
 * Fetch Students
 */
export const listStudentsOptions = (options: Options<ListStudentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listStudents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStudentsQueryKey(options)
    });
};

export const getStudentQueryKey = (options: Options<GetStudentData>) => createQueryKey('getStudent', options);

/**
 * Fetch Student By Id
 */
export const getStudentOptions = (options: Options<GetStudentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStudent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStudentQueryKey(options)
    });
};

/**
 * Update Student by Id
 */
export const updateStudentMutation = (options?: Partial<Options<UpdateStudentData>>): UseMutationOptions<UpdateStudentResponse, AxiosError<UpdateStudentError>, Options<UpdateStudentData>> => {
    const mutationOptions: UseMutationOptions<UpdateStudentResponse, AxiosError<UpdateStudentError>, Options<UpdateStudentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateStudent({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStudentCourseEnrollmentsQueryKey = (options: Options<ListStudentCourseEnrollmentsData>) => createQueryKey('listStudentCourseEnrollments', options);

/**
 * Fetch Students Course Enrollments
 */
export const listStudentCourseEnrollmentsOptions = (options: Options<ListStudentCourseEnrollmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listStudentCourseEnrollments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStudentCourseEnrollmentsQueryKey(options)
    });
};

export const listSelfSchedulePeriodsQueryKey = (options: Options<ListSelfSchedulePeriodsData>) => createQueryKey('listSelfSchedulePeriods', options);

/**
 * Fetch course periods for self scheduled course enrollment
 */
export const listSelfSchedulePeriodsOptions = (options: Options<ListSelfSchedulePeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSelfSchedulePeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSelfSchedulePeriodsQueryKey(options)
    });
};

export const listSelfSchedulePeriodsInfiniteQueryKey = (options: Options<ListSelfSchedulePeriodsData>): QueryKey<Options<ListSelfSchedulePeriodsData>> => createQueryKey('listSelfSchedulePeriods', options, true);

/**
 * Fetch course periods for self scheduled course enrollment
 */
export const listSelfSchedulePeriodsInfiniteOptions = (options: Options<ListSelfSchedulePeriodsData>) => {
    return infiniteQueryOptions<ListSelfSchedulePeriodsResponse, AxiosError<ListSelfSchedulePeriodsError>, InfiniteData<ListSelfSchedulePeriodsResponse>, QueryKey<Options<ListSelfSchedulePeriodsData>>, string | Pick<QueryKey<Options<ListSelfSchedulePeriodsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSelfSchedulePeriodsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSelfSchedulePeriods({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSelfSchedulePeriodsInfiniteQueryKey(options)
    });
};

export const countSelfSchedulePeriodsQueryKey = (options: Options<CountSelfSchedulePeriodsData>) => createQueryKey('countSelfSchedulePeriods', options);

/**
 * Count self scheduled course periods between two dates
 */
export const countSelfSchedulePeriodsOptions = (options: Options<CountSelfSchedulePeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await countSelfSchedulePeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countSelfSchedulePeriodsQueryKey(options)
    });
};

export const countSelfSchedulePeriodsInfiniteQueryKey = (options: Options<CountSelfSchedulePeriodsData>): QueryKey<Options<CountSelfSchedulePeriodsData>> => createQueryKey('countSelfSchedulePeriods', options, true);

/**
 * Count self scheduled course periods between two dates
 */
export const countSelfSchedulePeriodsInfiniteOptions = (options: Options<CountSelfSchedulePeriodsData>) => {
    return infiniteQueryOptions<CountSelfSchedulePeriodsResponse, AxiosError<CountSelfSchedulePeriodsError>, InfiniteData<CountSelfSchedulePeriodsResponse>, QueryKey<Options<CountSelfSchedulePeriodsData>>, string | Pick<QueryKey<Options<CountSelfSchedulePeriodsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CountSelfSchedulePeriodsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await countSelfSchedulePeriods({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countSelfSchedulePeriodsInfiniteQueryKey(options)
    });
};

export const getStudentSelfScheduleEligibilityQueryKey = (options: Options<GetStudentSelfScheduleEligibilityData>) => createQueryKey('getStudentSelfScheduleEligibility', options);

/**
 * Get self-schedule eligibility for a course enrollment
 * Returns comprehensive eligibility information including all blocking rules and restrictions that prevent or limit a student from booking self-scheduled driving lessons.
 *
 */
export const getStudentSelfScheduleEligibilityOptions = (options: Options<GetStudentSelfScheduleEligibilityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStudentSelfScheduleEligibility({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStudentSelfScheduleEligibilityQueryKey(options)
    });
};

export const getStudentLedgerQueryKey = (options: Options<GetStudentLedgerData>) => createQueryKey('getStudentLedger', options);

/**
 * Fetch Ledger Student By Id
 */
export const getStudentLedgerOptions = (options: Options<GetStudentLedgerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStudentLedger({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStudentLedgerQueryKey(options)
    });
};

export const getStudentScheduleQueryKey = (options: Options<GetStudentScheduleData>) => createQueryKey('getStudentSchedule', options);

/**
 * Fetch course periods by student id
 */
export const getStudentScheduleOptions = (options: Options<GetStudentScheduleData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStudentSchedule({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStudentScheduleQueryKey(options)
    });
};

/**
 * Update permit by student ID
 */
export const updateStudentPermitMutation = (options?: Partial<Options<UpdateStudentPermitData>>): UseMutationOptions<UpdateStudentPermitResponse, AxiosError<UpdateStudentPermitError>, Options<UpdateStudentPermitData>> => {
    const mutationOptions: UseMutationOptions<UpdateStudentPermitResponse, AxiosError<UpdateStudentPermitError>, Options<UpdateStudentPermitData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateStudentPermit({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStudentIssuedFormsQueryKey = (options: Options<ListStudentIssuedFormsData>) => createQueryKey('listStudentIssuedForms', options);

/**
 * Fetch Issued Forms For Student By Id
 */
export const listStudentIssuedFormsOptions = (options: Options<ListStudentIssuedFormsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listStudentIssuedForms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStudentIssuedFormsQueryKey(options)
    });
};

export const listStudentIssuedFormsInfiniteQueryKey = (options: Options<ListStudentIssuedFormsData>): QueryKey<Options<ListStudentIssuedFormsData>> => createQueryKey('listStudentIssuedForms', options, true);

/**
 * Fetch Issued Forms For Student By Id
 */
export const listStudentIssuedFormsInfiniteOptions = (options: Options<ListStudentIssuedFormsData>) => {
    return infiniteQueryOptions<ListStudentIssuedFormsResponse, AxiosError<ListStudentIssuedFormsError>, InfiniteData<ListStudentIssuedFormsResponse>, QueryKey<Options<ListStudentIssuedFormsData>>, number | Pick<QueryKey<Options<ListStudentIssuedFormsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListStudentIssuedFormsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listStudentIssuedForms({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listStudentIssuedFormsInfiniteQueryKey(options)
    });
};

export const searchStudentsQueryKey = (options?: Options<SearchStudentsData>) => createQueryKey('searchStudents', options);

/**
 * Search students
 */
export const searchStudentsOptions = (options?: Options<SearchStudentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchStudents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchStudentsQueryKey(options)
    });
};

/**
 * Search students
 */
export const searchStudentsMutation = (options?: Partial<Options<SearchStudentsData>>): UseMutationOptions<SearchStudentsResponse, AxiosError<SearchStudentsError>, Options<SearchStudentsData>> => {
    const mutationOptions: UseMutationOptions<SearchStudentsResponse, AxiosError<SearchStudentsError>, Options<SearchStudentsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await searchStudents({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPackagesQueryKey = (options?: Options<ListPackagesData>) => createQueryKey('listPackages', options);

/**
 * Get All Packages
 */
export const listPackagesOptions = (options?: Options<ListPackagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPackages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPackagesQueryKey(options)
    });
};

export const getPackageQueryKey = (options: Options<GetPackageData>) => createQueryKey('getPackage', options);

/**
 * Get All Packages
 */
export const getPackageOptions = (options: Options<GetPackageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPackage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPackageQueryKey(options)
    });
};

/**
 * Update a Package
 */
export const updatePackageMutation = (options?: Partial<Options<UpdatePackageData>>): UseMutationOptions<UpdatePackageResponse, AxiosError<UpdatePackageError>, Options<UpdatePackageData>> => {
    const mutationOptions: UseMutationOptions<UpdatePackageResponse, AxiosError<UpdatePackageError>, Options<UpdatePackageData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updatePackage({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update the agreement for a specific package
 */
export const updatePackageAgreementMutation = (options?: Partial<Options<UpdatePackageAgreementData>>): UseMutationOptions<UpdatePackageAgreementResponse, AxiosError<UpdatePackageAgreementError>, Options<UpdatePackageAgreementData>> => {
    const mutationOptions: UseMutationOptions<UpdatePackageAgreementResponse, AxiosError<UpdatePackageAgreementError>, Options<UpdatePackageAgreementData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updatePackageAgreement({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCoursesQueryKey = (options?: Options<ListCoursesData>) => createQueryKey('listCourses', options);

/**
 * Get All Courses
 */
export const listCoursesOptions = (options?: Options<ListCoursesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCourses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCoursesQueryKey(options)
    });
};

export const getCourseQueryKey = (options: Options<GetCourseData>) => createQueryKey('getCourse', options);

/**
 * Fetch Course By Id
 */
export const getCourseOptions = (options: Options<GetCourseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCourse({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseQueryKey(options)
    });
};

export const getCoursePolicyQueryKey = (options: Options<GetCoursePolicyData>) => createQueryKey('getCoursePolicy', options);

/**
 * Fetch Course Policy By Course Id
 */
export const getCoursePolicyOptions = (options: Options<GetCoursePolicyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCoursePolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCoursePolicyQueryKey(options)
    });
};

/**
 * Update The Policy For A Course
 */
export const updateCoursePolicyMutation = (options?: Partial<Options<UpdateCoursePolicyData>>): UseMutationOptions<UpdateCoursePolicyResponse, AxiosError<UpdateCoursePolicyError>, Options<UpdateCoursePolicyData>> => {
    const mutationOptions: UseMutationOptions<UpdateCoursePolicyResponse, AxiosError<UpdateCoursePolicyError>, Options<UpdateCoursePolicyData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateCoursePolicy({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSelfScheduleCriteriaQueryKey = (options: Options<GetSelfScheduleCriteriaData>) => createQueryKey('getSelfScheduleCriteria', options);

/**
 * Fetch Course Policy By Course Id
 */
export const getSelfScheduleCriteriaOptions = (options: Options<GetSelfScheduleCriteriaData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSelfScheduleCriteria({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSelfScheduleCriteriaQueryKey(options)
    });
};

/**
 * Update The Self Schedule Criteria For A Course
 */
export const updateSelfScheduleCriteriaMutation = (options?: Partial<Options<UpdateSelfScheduleCriteriaData>>): UseMutationOptions<UpdateSelfScheduleCriteriaResponse, AxiosError<UpdateSelfScheduleCriteriaError>, Options<UpdateSelfScheduleCriteriaData>> => {
    const mutationOptions: UseMutationOptions<UpdateSelfScheduleCriteriaResponse, AxiosError<UpdateSelfScheduleCriteriaError>, Options<UpdateSelfScheduleCriteriaData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateSelfScheduleCriteria({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCourseEnrollmentCriteriaQueryKey = (options: Options<GetCourseEnrollmentCriteriaData>) => createQueryKey('getCourseEnrollmentCriteria', options);

/**
 * Fetch Course Enollment Criteria By Course Id
 */
export const getCourseEnrollmentCriteriaOptions = (options: Options<GetCourseEnrollmentCriteriaData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCourseEnrollmentCriteria({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseEnrollmentCriteriaQueryKey(options)
    });
};

/**
 * Update The Course Enollment Criteria For A Course
 */
export const updateCourseEnrollmentCriteriaMutation = (options?: Partial<Options<UpdateCourseEnrollmentCriteriaData>>): UseMutationOptions<UpdateCourseEnrollmentCriteriaResponse, AxiosError<UpdateCourseEnrollmentCriteriaError>, Options<UpdateCourseEnrollmentCriteriaData>> => {
    const mutationOptions: UseMutationOptions<UpdateCourseEnrollmentCriteriaResponse, AxiosError<UpdateCourseEnrollmentCriteriaError>, Options<UpdateCourseEnrollmentCriteriaData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateCourseEnrollmentCriteria({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCourseCompletionCriteriaQueryKey = (options: Options<GetCourseCompletionCriteriaData>) => createQueryKey('getCourseCompletionCriteria', options);

/**
 * Fetch Course Completion Criteria By Course Id
 */
export const getCourseCompletionCriteriaOptions = (options: Options<GetCourseCompletionCriteriaData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCourseCompletionCriteria({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseCompletionCriteriaQueryKey(options)
    });
};

/**
 * Update The Course Completion Criteria For A Course
 */
export const updateCourseCompletionCriteriaMutation = (options?: Partial<Options<UpdateCourseCompletionCriteriaData>>): UseMutationOptions<UpdateCourseCompletionCriteriaResponse, AxiosError<UpdateCourseCompletionCriteriaError>, Options<UpdateCourseCompletionCriteriaData>> => {
    const mutationOptions: UseMutationOptions<UpdateCourseCompletionCriteriaResponse, AxiosError<UpdateCourseCompletionCriteriaError>, Options<UpdateCourseCompletionCriteriaData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateCourseCompletionCriteria({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update the agreement for a specific course
 */
export const updateCourseAgreementMutation = (options?: Partial<Options<UpdateCourseAgreementData>>): UseMutationOptions<UpdateCourseAgreementResponse, AxiosError<UpdateCourseAgreementError>, Options<UpdateCourseAgreementData>> => {
    const mutationOptions: UseMutationOptions<UpdateCourseAgreementResponse, AxiosError<UpdateCourseAgreementError>, Options<UpdateCourseAgreementData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateCourseAgreement({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update public notes for a period enrollment
 */
export const updatePeriodEnrollmentMutation = (options?: Partial<Options<UpdatePeriodEnrollmentData>>): UseMutationOptions<UpdatePeriodEnrollmentResponse, AxiosError<UpdatePeriodEnrollmentError>, Options<UpdatePeriodEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<UpdatePeriodEnrollmentResponse, AxiosError<UpdatePeriodEnrollmentError>, Options<UpdatePeriodEnrollmentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updatePeriodEnrollment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update private notes for a period enrollment
 */
export const updatePeriodEnrollmentPrivateNotesMutation = (options?: Partial<Options<UpdatePeriodEnrollmentPrivateNotesData>>): UseMutationOptions<UpdatePeriodEnrollmentPrivateNotesResponse, AxiosError<UpdatePeriodEnrollmentPrivateNotesError>, Options<UpdatePeriodEnrollmentPrivateNotesData>> => {
    const mutationOptions: UseMutationOptions<UpdatePeriodEnrollmentPrivateNotesResponse, AxiosError<UpdatePeriodEnrollmentPrivateNotesError>, Options<UpdatePeriodEnrollmentPrivateNotesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updatePeriodEnrollmentPrivateNotes({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCourseSectionsQueryKey = (options: Options<ListCourseSectionsData>) => createQueryKey('listCourseSections', options);

/**
 * Get Course Sections
 */
export const listCourseSectionsOptions = (options: Options<ListCourseSectionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCourseSections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCourseSectionsQueryKey(options)
    });
};

export const listCourseSectionsInfiniteQueryKey = (options: Options<ListCourseSectionsData>): QueryKey<Options<ListCourseSectionsData>> => createQueryKey('listCourseSections', options, true);

/**
 * Get Course Sections
 */
export const listCourseSectionsInfiniteOptions = (options: Options<ListCourseSectionsData>) => {
    return infiniteQueryOptions<ListCourseSectionsResponse, AxiosError<ListCourseSectionsError>, InfiniteData<ListCourseSectionsResponse>, QueryKey<Options<ListCourseSectionsData>>, number | Pick<QueryKey<Options<ListCourseSectionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListCourseSectionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listCourseSections({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCourseSectionsInfiniteQueryKey(options)
    });
};

export const getCourseSectionQueryKey = (options: Options<GetCourseSectionData>) => createQueryKey('getCourseSection', options);

/**
 * Fetch Section By Id
 */
export const getCourseSectionOptions = (options: Options<GetCourseSectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCourseSection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseSectionQueryKey(options)
    });
};

export const listSectionEnrollmentsQueryKey = (options: Options<ListSectionEnrollmentsData>) => createQueryKey('listSectionEnrollments', options);

/**
 * Fetch Enrollments by Section By Id
 */
export const listSectionEnrollmentsOptions = (options: Options<ListSectionEnrollmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSectionEnrollments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSectionEnrollmentsQueryKey(options)
    });
};

export const listSectionEnrollmentsInfiniteQueryKey = (options: Options<ListSectionEnrollmentsData>): QueryKey<Options<ListSectionEnrollmentsData>> => createQueryKey('listSectionEnrollments', options, true);

/**
 * Fetch Enrollments by Section By Id
 */
export const listSectionEnrollmentsInfiniteOptions = (options: Options<ListSectionEnrollmentsData>) => {
    return infiniteQueryOptions<ListSectionEnrollmentsResponse, AxiosError<ListSectionEnrollmentsError>, InfiniteData<ListSectionEnrollmentsResponse>, QueryKey<Options<ListSectionEnrollmentsData>>, number | Pick<QueryKey<Options<ListSectionEnrollmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSectionEnrollmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSectionEnrollments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSectionEnrollmentsInfiniteQueryKey(options)
    });
};

/**
 * Fetch Enrollments by Section By Id
 */
export const listSectionEnrollmentsMutation = (options?: Partial<Options<ListSectionEnrollmentsData>>): UseMutationOptions<ListSectionEnrollmentsResponse, AxiosError<ListSectionEnrollmentsError>, Options<ListSectionEnrollmentsData>> => {
    const mutationOptions: UseMutationOptions<ListSectionEnrollmentsResponse, AxiosError<ListSectionEnrollmentsError>, Options<ListSectionEnrollmentsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await listSectionEnrollments({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSectionPeriodsQueryKey = (options: Options<ListSectionPeriodsData>) => createQueryKey('listSectionPeriods', options);

/**
 * Fetch Periods by Section By Id
 */
export const listSectionPeriodsOptions = (options: Options<ListSectionPeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSectionPeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSectionPeriodsQueryKey(options)
    });
};

export const listSectionPeriodsInfiniteQueryKey = (options: Options<ListSectionPeriodsData>): QueryKey<Options<ListSectionPeriodsData>> => createQueryKey('listSectionPeriods', options, true);

/**
 * Fetch Periods by Section By Id
 */
export const listSectionPeriodsInfiniteOptions = (options: Options<ListSectionPeriodsData>) => {
    return infiniteQueryOptions<ListSectionPeriodsResponse, AxiosError<ListSectionPeriodsError>, InfiniteData<ListSectionPeriodsResponse>, QueryKey<Options<ListSectionPeriodsData>>, number | Pick<QueryKey<Options<ListSectionPeriodsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSectionPeriodsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSectionPeriods({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSectionPeriodsInfiniteQueryKey(options)
    });
};

export const getCourseInstructorPoolQueryKey = (options: Options<GetCourseInstructorPoolData>) => createQueryKey('getCourseInstructorPool', options);

/**
 * Get All Instructors Eligible To Teach Course
 */
export const getCourseInstructorPoolOptions = (options: Options<GetCourseInstructorPoolData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCourseInstructorPool({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseInstructorPoolQueryKey(options)
    });
};

export const getCourseInstructorPoolInfiniteQueryKey = (options: Options<GetCourseInstructorPoolData>): QueryKey<Options<GetCourseInstructorPoolData>> => createQueryKey('getCourseInstructorPool', options, true);

/**
 * Get All Instructors Eligible To Teach Course
 */
export const getCourseInstructorPoolInfiniteOptions = (options: Options<GetCourseInstructorPoolData>) => {
    return infiniteQueryOptions<GetCourseInstructorPoolResponse, AxiosError<GetCourseInstructorPoolError>, InfiniteData<GetCourseInstructorPoolResponse>, QueryKey<Options<GetCourseInstructorPoolData>>, number | Pick<QueryKey<Options<GetCourseInstructorPoolData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCourseInstructorPoolData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getCourseInstructorPool({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseInstructorPoolInfiniteQueryKey(options)
    });
};

export const takeAttendanceQueryKey = (options: Options<TakeAttendanceData>) => createQueryKey('takeAttendance', options);

/**
 * Take Attendance For Course Period
 */
export const takeAttendanceOptions = (options: Options<TakeAttendanceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await takeAttendance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: takeAttendanceQueryKey(options)
    });
};

/**
 * Take Attendance For Course Period
 */
export const takeAttendanceMutation = (options?: Partial<Options<TakeAttendanceData>>): UseMutationOptions<TakeAttendanceResponse, AxiosError<TakeAttendanceError>, Options<TakeAttendanceData>> => {
    const mutationOptions: UseMutationOptions<TakeAttendanceResponse, AxiosError<TakeAttendanceError>, Options<TakeAttendanceData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await takeAttendance({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchSectionEnrollmentsQueryKey = (options?: Options<SearchSectionEnrollmentsData>) => createQueryKey('searchSectionEnrollments', options);

/**
 * Search enrollments for course section
 */
export const searchSectionEnrollmentsOptions = (options?: Options<SearchSectionEnrollmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await searchSectionEnrollments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchSectionEnrollmentsQueryKey(options)
    });
};

export const searchSectionEnrollmentsInfiniteQueryKey = (options?: Options<SearchSectionEnrollmentsData>): QueryKey<Options<SearchSectionEnrollmentsData>> => createQueryKey('searchSectionEnrollments', options, true);

/**
 * Search enrollments for course section
 */
export const searchSectionEnrollmentsInfiniteOptions = (options?: Options<SearchSectionEnrollmentsData>) => {
    return infiniteQueryOptions<SearchSectionEnrollmentsResponse, AxiosError<SearchSectionEnrollmentsError>, InfiniteData<SearchSectionEnrollmentsResponse>, QueryKey<Options<SearchSectionEnrollmentsData>>, number | Pick<QueryKey<Options<SearchSectionEnrollmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<SearchSectionEnrollmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                body: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await searchSectionEnrollments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchSectionEnrollmentsInfiniteQueryKey(options)
    });
};

/**
 * Search enrollments for course section
 */
export const searchSectionEnrollmentsMutation = (options?: Partial<Options<SearchSectionEnrollmentsData>>): UseMutationOptions<SearchSectionEnrollmentsResponse, AxiosError<SearchSectionEnrollmentsError>, Options<SearchSectionEnrollmentsData>> => {
    const mutationOptions: UseMutationOptions<SearchSectionEnrollmentsResponse, AxiosError<SearchSectionEnrollmentsError>, Options<SearchSectionEnrollmentsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await searchSectionEnrollments({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enrollStudentInSectionQueryKey = (options: Options<EnrollStudentInSectionData>) => createQueryKey('enrollStudentInSection', options);

/**
 * Enroll a student in a course section
 */
export const enrollStudentInSectionOptions = (options: Options<EnrollStudentInSectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await enrollStudentInSection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: enrollStudentInSectionQueryKey(options)
    });
};

/**
 * Enroll a student in a course section
 */
export const enrollStudentInSectionMutation = (options?: Partial<Options<EnrollStudentInSectionData>>): UseMutationOptions<EnrollStudentInSectionResponse, AxiosError<EnrollStudentInSectionError>, Options<EnrollStudentInSectionData>> => {
    const mutationOptions: UseMutationOptions<EnrollStudentInSectionResponse, AxiosError<EnrollStudentInSectionError>, Options<EnrollStudentInSectionData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await enrollStudentInSection({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCourseEnrollmentQueryKey = (options: Options<GetCourseEnrollmentData>) => createQueryKey('getCourseEnrollment', options);

/**
 * Get course enrollment by id
 */
export const getCourseEnrollmentOptions = (options: Options<GetCourseEnrollmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCourseEnrollment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseEnrollmentQueryKey(options)
    });
};

/**
 * Update the completion date for a course enrollment
 * Updates the completion date of a specific course enrollment.
 */
export const updateEnrollmentCompletionDateMutation = (options?: Partial<Options<UpdateEnrollmentCompletionDateData>>): UseMutationOptions<UpdateEnrollmentCompletionDateResponse, AxiosError<UpdateEnrollmentCompletionDateError>, Options<UpdateEnrollmentCompletionDateData>> => {
    const mutationOptions: UseMutationOptions<UpdateEnrollmentCompletionDateResponse, AxiosError<UpdateEnrollmentCompletionDateError>, Options<UpdateEnrollmentCompletionDateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateEnrollmentCompletionDate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCoursePeriodQueryKey = (options: Options<GetCoursePeriodData>) => createQueryKey('getCoursePeriod', options);

/**
 * Fetch Course Period
 */
export const getCoursePeriodOptions = (options: Options<GetCoursePeriodData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCoursePeriod({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCoursePeriodQueryKey(options)
    });
};

/**
 * Update course period by ID
 * Update a specific course period using its unique identifier.
 */
export const updateCoursePeriodMutation = (options?: Partial<Options<UpdateCoursePeriodData>>): UseMutationOptions<UpdateCoursePeriodResponse, AxiosError<UpdateCoursePeriodError>, Options<UpdateCoursePeriodData>> => {
    const mutationOptions: UseMutationOptions<UpdateCoursePeriodResponse, AxiosError<UpdateCoursePeriodError>, Options<UpdateCoursePeriodData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateCoursePeriod({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPeriodEnrollmentsQueryKey = (options: Options<ListPeriodEnrollmentsData>) => createQueryKey('listPeriodEnrollments', options);

/**
 * Fetch Course Period Enrollments
 */
export const listPeriodEnrollmentsOptions = (options: Options<ListPeriodEnrollmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPeriodEnrollments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPeriodEnrollmentsQueryKey(options)
    });
};

export const listCourseEnrollmentPeriodsQueryKey = (options: Options<ListCourseEnrollmentPeriodsData>) => createQueryKey('listCourseEnrollmentPeriods', options);

/**
 * Fetch Course Periods For Course Enrollment
 */
export const listCourseEnrollmentPeriodsOptions = (options: Options<ListCourseEnrollmentPeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCourseEnrollmentPeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCourseEnrollmentPeriodsQueryKey(options)
    });
};

export const cancelPeriodEnrollmentQueryKey = (options: Options<CancelPeriodEnrollmentData>) => createQueryKey('cancelPeriodEnrollment', options);

/**
 * Cancel period enrollment
 */
export const cancelPeriodEnrollmentOptions = (options: Options<CancelPeriodEnrollmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cancelPeriodEnrollment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cancelPeriodEnrollmentQueryKey(options)
    });
};

/**
 * Cancel period enrollment
 */
export const cancelPeriodEnrollmentMutation = (options?: Partial<Options<CancelPeriodEnrollmentData>>): UseMutationOptions<CancelPeriodEnrollmentResponse, AxiosError<CancelPeriodEnrollmentError>, Options<CancelPeriodEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<CancelPeriodEnrollmentResponse, AxiosError<CancelPeriodEnrollmentError>, Options<CancelPeriodEnrollmentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelPeriodEnrollment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete course periods
 * Delete multiple course periods using their unique identifiers.
 */
export const deleteCoursePeriodsMutation = (options?: Partial<Options<DeleteCoursePeriodsData>>): UseMutationOptions<DeleteCoursePeriodsResponse, AxiosError<DeleteCoursePeriodsError>, Options<DeleteCoursePeriodsData>> => {
    const mutationOptions: UseMutationOptions<DeleteCoursePeriodsResponse, AxiosError<DeleteCoursePeriodsError>, Options<DeleteCoursePeriodsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteCoursePeriods({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCoursePeriodsQueryKey = (options: Options<ListCoursePeriodsData>) => createQueryKey('listCoursePeriods', options);

/**
 * Fetch All Course Periods
 */
export const listCoursePeriodsOptions = (options: Options<ListCoursePeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCoursePeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCoursePeriodsQueryKey(options)
    });
};

export const listCoursePeriodsInfiniteQueryKey = (options: Options<ListCoursePeriodsData>): QueryKey<Options<ListCoursePeriodsData>> => createQueryKey('listCoursePeriods', options, true);

/**
 * Fetch All Course Periods
 */
export const listCoursePeriodsInfiniteOptions = (options: Options<ListCoursePeriodsData>) => {
    return infiniteQueryOptions<ListCoursePeriodsResponse, AxiosError<ListCoursePeriodsError>, InfiniteData<ListCoursePeriodsResponse>, QueryKey<Options<ListCoursePeriodsData>>, string | Pick<QueryKey<Options<ListCoursePeriodsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListCoursePeriodsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listCoursePeriods({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCoursePeriodsInfiniteQueryKey(options)
    });
};

export const createCoursePeriodsQueryKey = (options: Options<CreateCoursePeriodsData>) => createQueryKey('createCoursePeriods', options);

/**
 * Create new course periods
 */
export const createCoursePeriodsOptions = (options: Options<CreateCoursePeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createCoursePeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createCoursePeriodsQueryKey(options)
    });
};

/**
 * Create new course periods
 */
export const createCoursePeriodsMutation = (options?: Partial<Options<CreateCoursePeriodsData>>): UseMutationOptions<CreateCoursePeriodsResponse, AxiosError<CreateCoursePeriodsError>, Options<CreateCoursePeriodsData>> => {
    const mutationOptions: UseMutationOptions<CreateCoursePeriodsResponse, AxiosError<CreateCoursePeriodsError>, Options<CreateCoursePeriodsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createCoursePeriods({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enrollStudentInPeriodQueryKey = (options: Options<EnrollStudentInPeriodData>) => createQueryKey('enrollStudentInPeriod', options);

/**
 * Enroll a student in a course period
 */
export const enrollStudentInPeriodOptions = (options: Options<EnrollStudentInPeriodData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await enrollStudentInPeriod({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: enrollStudentInPeriodQueryKey(options)
    });
};

/**
 * Enroll a student in a course period
 */
export const enrollStudentInPeriodMutation = (options?: Partial<Options<EnrollStudentInPeriodData>>): UseMutationOptions<EnrollStudentInPeriodResponse, AxiosError<EnrollStudentInPeriodError>, Options<EnrollStudentInPeriodData>> => {
    const mutationOptions: UseMutationOptions<EnrollStudentInPeriodResponse, AxiosError<EnrollStudentInPeriodError>, Options<EnrollStudentInPeriodData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await enrollStudentInPeriod({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enrollStudentInPeriodWaitlistQueryKey = (options: Options<EnrollStudentInPeriodWaitlistData>) => createQueryKey('enrollStudentInPeriodWaitlist', options);

/**
 * Enroll a student in a course period waitlist
 */
export const enrollStudentInPeriodWaitlistOptions = (options: Options<EnrollStudentInPeriodWaitlistData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await enrollStudentInPeriodWaitlist({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: enrollStudentInPeriodWaitlistQueryKey(options)
    });
};

/**
 * Enroll a student in a course period waitlist
 */
export const enrollStudentInPeriodWaitlistMutation = (options?: Partial<Options<EnrollStudentInPeriodWaitlistData>>): UseMutationOptions<EnrollStudentInPeriodWaitlistResponse, AxiosError<EnrollStudentInPeriodWaitlistError>, Options<EnrollStudentInPeriodWaitlistData>> => {
    const mutationOptions: UseMutationOptions<EnrollStudentInPeriodWaitlistResponse, AxiosError<EnrollStudentInPeriodWaitlistError>, Options<EnrollStudentInPeriodWaitlistData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await enrollStudentInPeriodWaitlist({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete course period enrollment
 */
export const deletePeriodEnrollmentMutation = (options?: Partial<Options<DeletePeriodEnrollmentData>>): UseMutationOptions<DeletePeriodEnrollmentResponse, AxiosError<DeletePeriodEnrollmentError>, Options<DeletePeriodEnrollmentData>> => {
    const mutationOptions: UseMutationOptions<DeletePeriodEnrollmentResponse, AxiosError<DeletePeriodEnrollmentError>, Options<DeletePeriodEnrollmentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deletePeriodEnrollment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFormTemplatesQueryKey = (options?: Options<ListFormTemplatesData>) => createQueryKey('listFormTemplates', options);

/**
 * Get Tenant Forms
 */
export const listFormTemplatesOptions = (options?: Options<ListFormTemplatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFormTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFormTemplatesQueryKey(options)
    });
};

export const getFormTemplateQueryKey = (options: Options<GetFormTemplateData>) => createQueryKey('getFormTemplate', options);

/**
 * Get Form
 */
export const getFormTemplateOptions = (options: Options<GetFormTemplateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFormTemplate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFormTemplateQueryKey(options)
    });
};

export const issueFormQueryKey = (options: Options<IssueFormData>) => createQueryKey('issueForm', options);

/**
 * Fill and Issue Form Template
 */
export const issueFormOptions = (options: Options<IssueFormData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await issueForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: issueFormQueryKey(options)
    });
};

/**
 * Fill and Issue Form Template
 */
export const issueFormMutation = (options?: Partial<Options<IssueFormData>>): UseMutationOptions<IssueFormResponse, AxiosError<IssueFormError>, Options<IssueFormData>> => {
    const mutationOptions: UseMutationOptions<IssueFormResponse, AxiosError<IssueFormError>, Options<IssueFormData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await issueForm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const issueIndianaEnrollmentCertificationFormQueryKey = (options: Options<IssueIndianaEnrollmentCertificationFormData>) => createQueryKey('issueIndianaEnrollmentCertificationForm', options);

/**
 * Issue Indiana CDE Form
 */
export const issueIndianaEnrollmentCertificationFormOptions = (options: Options<IssueIndianaEnrollmentCertificationFormData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await issueIndianaEnrollmentCertificationForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: issueIndianaEnrollmentCertificationFormQueryKey(options)
    });
};

/**
 * Issue Indiana CDE Form
 */
export const issueIndianaEnrollmentCertificationFormMutation = (options?: Partial<Options<IssueIndianaEnrollmentCertificationFormData>>): UseMutationOptions<IssueIndianaEnrollmentCertificationFormResponse, AxiosError<IssueIndianaEnrollmentCertificationFormError>, Options<IssueIndianaEnrollmentCertificationFormData>> => {
    const mutationOptions: UseMutationOptions<IssueIndianaEnrollmentCertificationFormResponse, AxiosError<IssueIndianaEnrollmentCertificationFormError>, Options<IssueIndianaEnrollmentCertificationFormData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await issueIndianaEnrollmentCertificationForm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const issueIndianaCompletionPermitFormQueryKey = (options: Options<IssueIndianaCompletionPermitFormData>) => createQueryKey('issueIndianaCompletionPermitForm', options);

/**
 * Generate Indiana Completion of Driver Training School Course Permit Form
 */
export const issueIndianaCompletionPermitFormOptions = (options: Options<IssueIndianaCompletionPermitFormData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await issueIndianaCompletionPermitForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: issueIndianaCompletionPermitFormQueryKey(options)
    });
};

/**
 * Generate Indiana Completion of Driver Training School Course Permit Form
 */
export const issueIndianaCompletionPermitFormMutation = (options?: Partial<Options<IssueIndianaCompletionPermitFormData>>): UseMutationOptions<IssueIndianaCompletionPermitFormResponse, AxiosError<IssueIndianaCompletionPermitFormError>, Options<IssueIndianaCompletionPermitFormData>> => {
    const mutationOptions: UseMutationOptions<IssueIndianaCompletionPermitFormResponse, AxiosError<IssueIndianaCompletionPermitFormError>, Options<IssueIndianaCompletionPermitFormData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await issueIndianaCompletionPermitForm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIssuedFormQueryKey = (options: Options<GetIssuedFormData>) => createQueryKey('getIssuedForm', options);

/**
 * Download Issued Form By Id
 */
export const getIssuedFormOptions = (options: Options<GetIssuedFormData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getIssuedForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getIssuedFormQueryKey(options)
    });
};

export const getIssuedFormLinkQueryKey = (options: Options<GetIssuedFormLinkData>) => createQueryKey('getIssuedFormLink', options);

/**
 * Fetch Link To Issued Form By Id
 */
export const getIssuedFormLinkOptions = (options: Options<GetIssuedFormLinkData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getIssuedFormLink({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getIssuedFormLinkQueryKey(options)
    });
};

export const emailIssuedFormQueryKey = (options: Options<EmailIssuedFormData>) => createQueryKey('emailIssuedForm', options);

/**
 * Send form email template
 */
export const emailIssuedFormOptions = (options: Options<EmailIssuedFormData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await emailIssuedForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: emailIssuedFormQueryKey(options)
    });
};

/**
 * Send form email template
 */
export const emailIssuedFormMutation = (options?: Partial<Options<EmailIssuedFormData>>): UseMutationOptions<EmailIssuedFormResponse, AxiosError<EmailIssuedFormError>, Options<EmailIssuedFormData>> => {
    const mutationOptions: UseMutationOptions<EmailIssuedFormResponse, AxiosError<EmailIssuedFormError>, Options<EmailIssuedFormData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await emailIssuedForm({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCalendarFeedQueryKey = (options: Options<GetCalendarFeedData>) => createQueryKey('getCalendarFeed', options);

/**
 * Calendar Feed in ICS format
 */
export const getCalendarFeedOptions = (options: Options<GetCalendarFeedData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCalendarFeed({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCalendarFeedQueryKey(options)
    });
};

/**
 * Delete charge
 */
export const deleteChargeMutation = (options?: Partial<Options<DeleteChargeData>>): UseMutationOptions<DeleteChargeResponse, AxiosError<DeleteChargeError>, Options<DeleteChargeData>> => {
    const mutationOptions: UseMutationOptions<DeleteChargeResponse, AxiosError<DeleteChargeError>, Options<DeleteChargeData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteCharge({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listChargesQueryKey = (options?: Options<ListChargesData>) => createQueryKey('listCharges', options);

/**
 * Get charges
 */
export const listChargesOptions = (options?: Options<ListChargesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCharges({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listChargesQueryKey(options)
    });
};

export const createChargeQueryKey = (options: Options<CreateChargeData>) => createQueryKey('createCharge', options);

/**
 * Update charge
 */
export const createChargeOptions = (options: Options<CreateChargeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createCharge({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createChargeQueryKey(options)
    });
};

/**
 * Update charge
 */
export const createChargeMutation = (options?: Partial<Options<CreateChargeData>>): UseMutationOptions<CreateChargeResponse, AxiosError<CreateChargeError>, Options<CreateChargeData>> => {
    const mutationOptions: UseMutationOptions<CreateChargeResponse, AxiosError<CreateChargeError>, Options<CreateChargeData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createCharge({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getChargeQueryKey = (options: Options<GetChargeData>) => createQueryKey('getCharge', options);

/**
 * Get charge
 */
export const getChargeOptions = (options: Options<GetChargeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCharge({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getChargeQueryKey(options)
    });
};

/**
 * Update charge
 */
export const updateChargeMutation = (options?: Partial<Options<UpdateChargeData>>): UseMutationOptions<UpdateChargeResponse, AxiosError<UpdateChargeError>, Options<UpdateChargeData>> => {
    const mutationOptions: UseMutationOptions<UpdateChargeResponse, AxiosError<UpdateChargeError>, Options<UpdateChargeData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateCharge({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Void a charge
 * Marks a charge as voided with a reason
 */
export const voidChargeMutation = (options?: Partial<Options<VoidChargeData>>): UseMutationOptions<VoidChargeResponse, AxiosError<VoidChargeError>, Options<VoidChargeData>> => {
    const mutationOptions: UseMutationOptions<VoidChargeResponse, AxiosError<VoidChargeError>, Options<VoidChargeData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await voidCharge({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPaymentsQueryKey = (options?: Options<ListPaymentsData>) => createQueryKey('listPayments', options);

/**
 * Retrieve payments
 * Returns a list of payments. Can be filtered by student ID.
 *
 */
export const listPaymentsOptions = (options?: Options<ListPaymentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPaymentsQueryKey(options)
    });
};

export const createPaymentQueryKey = (options: Options<CreatePaymentData>) => createQueryKey('createPayment', options);

/**
 * Create a new payment
 * Create a new payment record. The request body must conform to the PaymentForm schema. Note that the `id` field should be null when creating a new payment.
 *
 */
export const createPaymentOptions = (options: Options<CreatePaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createPaymentQueryKey(options)
    });
};

/**
 * Create a new payment
 * Create a new payment record. The request body must conform to the PaymentForm schema. Note that the `id` field should be null when creating a new payment.
 *
 */
export const createPaymentMutation = (options?: Partial<Options<CreatePaymentData>>): UseMutationOptions<CreatePaymentResponse, AxiosError<CreatePaymentError>, Options<CreatePaymentData>> => {
    const mutationOptions: UseMutationOptions<CreatePaymentResponse, AxiosError<CreatePaymentError>, Options<CreatePaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPaymentQueryKey = (options: Options<GetPaymentData>) => createQueryKey('getPayment', options);

/**
 * Get payment
 */
export const getPaymentOptions = (options: Options<GetPaymentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPaymentQueryKey(options)
    });
};

/**
 * Update an existing payment
 * Update an existing payment record. The `paymentId` path parameter identifies the payment to update. The request body must conform to the PaymentForm schema.
 *
 */
export const updatePaymentMutation = (options?: Partial<Options<UpdatePaymentData>>): UseMutationOptions<UpdatePaymentResponse, AxiosError<UpdatePaymentError>, Options<UpdatePaymentData>> => {
    const mutationOptions: UseMutationOptions<UpdatePaymentResponse, AxiosError<UpdatePaymentError>, Options<UpdatePaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updatePayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Void a payment
 * Marks a payment as voided with a reason
 */
export const voidPaymentMutation = (options?: Partial<Options<VoidPaymentData>>): UseMutationOptions<VoidPaymentResponse, AxiosError<VoidPaymentError>, Options<VoidPaymentData>> => {
    const mutationOptions: UseMutationOptions<VoidPaymentResponse, AxiosError<VoidPaymentError>, Options<VoidPaymentData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await voidPayment({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDiscountsQueryKey = (options?: Options<ListDiscountsData>) => createQueryKey('listDiscounts', options);

/**
 * Get list of discounts
 */
export const listDiscountsOptions = (options?: Options<ListDiscountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listDiscounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDiscountsQueryKey(options)
    });
};

export const listPaymentMethodsQueryKey = (options?: Options<ListPaymentMethodsData>) => createQueryKey('listPaymentMethods', options);

/**
 * Retrieve payment methods
 * Returns a list of payment methods filtered by type and status. The 'type' query parameter can be 'all', 'payments', or 'refunds' (default is 'all'). The 'status' query parameter is optional and filters based on whether a payment method is enabled.
 *
 */
export const listPaymentMethodsOptions = (options?: Options<ListPaymentMethodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPaymentMethods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPaymentMethodsQueryKey(options)
    });
};

export const listRefundsQueryKey = (options?: Options<ListRefundsData>) => createQueryKey('listRefunds', options);

/**
 * Retrieve refunds
 * Returns a list of refunds. Can be filtered by student ID. Students can only access their own refunds.
 *
 */
export const listRefundsOptions = (options?: Options<ListRefundsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listRefunds({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listRefundsQueryKey(options)
    });
};

export const createRefundQueryKey = (options: Options<CreateRefundData>) => createQueryKey('createRefund', options);

/**
 * Create a new refund
 * Create a new refund record. The request body must conform to the RefundForm schema. Note that the `id` field should be null when creating a new refund.
 *
 */
export const createRefundOptions = (options: Options<CreateRefundData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createRefund({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createRefundQueryKey(options)
    });
};

/**
 * Create a new refund
 * Create a new refund record. The request body must conform to the RefundForm schema. Note that the `id` field should be null when creating a new refund.
 *
 */
export const createRefundMutation = (options?: Partial<Options<CreateRefundData>>): UseMutationOptions<CreateRefundResponse, AxiosError<CreateRefundError>, Options<CreateRefundData>> => {
    const mutationOptions: UseMutationOptions<CreateRefundResponse, AxiosError<CreateRefundError>, Options<CreateRefundData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createRefund({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRefundQueryKey = (options: Options<GetRefundData>) => createQueryKey('getRefund', options);

/**
 * Retrieve a specific refund
 * Returns a specific refund by ID. Students can only access their own refunds.
 *
 */
export const getRefundOptions = (options: Options<GetRefundData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRefund({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRefundQueryKey(options)
    });
};

/**
 * Update an existing refund
 * Update an existing refund record. The `id` path parameter identifies the refund to update. The request body must conform to the RefundForm schema.
 *
 */
export const updateRefundMutation = (options?: Partial<Options<UpdateRefundData>>): UseMutationOptions<UpdateRefundResponse, AxiosError<UpdateRefundError>, Options<UpdateRefundData>> => {
    const mutationOptions: UseMutationOptions<UpdateRefundResponse, AxiosError<UpdateRefundError>, Options<UpdateRefundData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRefund({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Void a refund
 * Marks a refund as voided with a reason
 */
export const voidRefundMutation = (options?: Partial<Options<VoidRefundData>>): UseMutationOptions<VoidRefundResponse, AxiosError<VoidRefundError>, Options<VoidRefundData>> => {
    const mutationOptions: UseMutationOptions<VoidRefundResponse, AxiosError<VoidRefundError>, Options<VoidRefundData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await voidRefund({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTemplateQueryKey = (options: Options<GetTemplateData>) => createQueryKey('getTemplate', options);

/**
 * Get email and/or SMS template and available merge tags
 * Retrieves the email/SMS template for a specific record and includes the list of applicable merge tags.
 */
export const getTemplateOptions = (options: Options<GetTemplateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemplate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTemplateQueryKey(options)
    });
};

/**
 * Update email and/or SMS template for a specific record
 * Updates the email, SMS, or both templates for a record identified by the template key and ID. Supports partial updates.
 */
export const updateTemplateMutation = (options?: Partial<Options<UpdateTemplateData>>): UseMutationOptions<UpdateTemplateResponse, AxiosError<UpdateTemplateError>, Options<UpdateTemplateData>> => {
    const mutationOptions: UseMutationOptions<UpdateTemplateResponse, AxiosError<UpdateTemplateError>, Options<UpdateTemplateData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateTemplate({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listReportsQueryKey = (options?: Options<ListReportsData>) => createQueryKey('listReports', options);

/**
 * List available report definitions
 * Returns all available report definitions with dynamic select options populated from the database
 */
export const listReportsOptions = (options?: Options<ListReportsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listReports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listReportsQueryKey(options)
    });
};

export const getReportQueryKey = (options: Options<GetReportData>) => createQueryKey('getReport', options);

/**
 * Get a single report definition
 * Returns a single report definition by ID with dynamic select options populated
 */
export const getReportOptions = (options: Options<GetReportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getReportQueryKey(options)
    });
};

export const generateReportQueryKey = (options: Options<GenerateReportData>) => createQueryKey('generateReport', options);

/**
 * Generate and download a report
 * Generates a report with the specified parameters and format, returning the file as a download
 */
export const generateReportOptions = (options: Options<GenerateReportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await generateReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: generateReportQueryKey(options)
    });
};

/**
 * Generate and download a report
 * Generates a report with the specified parameters and format, returning the file as a download
 */
export const generateReportMutation = (options?: Partial<Options<GenerateReportData>>): UseMutationOptions<GenerateReportResponse, AxiosError<GenerateReportError>, Options<GenerateReportData>> => {
    const mutationOptions: UseMutationOptions<GenerateReportResponse, AxiosError<GenerateReportError>, Options<GenerateReportData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await generateReport({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyLearningCoursesQueryKey = (options?: Options<GetMyLearningCoursesData>) => createQueryKey('getMyLearningCourses', options);

export const getMyLearningCoursesOptions = (options?: Options<GetMyLearningCoursesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMyLearningCourses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMyLearningCoursesQueryKey(options)
    });
};

export const listCurriculaQueryKey = (options?: Options<ListCurriculaData>) => createQueryKey('listCurricula', options);

export const listCurriculaOptions = (options?: Options<ListCurriculaData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCurricula({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCurriculaQueryKey(options)
    });
};

export const createCurriculumQueryKey = (options: Options<CreateCurriculumData>) => createQueryKey('createCurriculum', options);

export const createCurriculumOptions = (options: Options<CreateCurriculumData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createCurriculum({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createCurriculumQueryKey(options)
    });
};

export const createCurriculumMutation = (options?: Partial<Options<CreateCurriculumData>>): UseMutationOptions<CreateCurriculumResponse, AxiosError<CreateCurriculumError>, Options<CreateCurriculumData>> => {
    const mutationOptions: UseMutationOptions<CreateCurriculumResponse, AxiosError<CreateCurriculumError>, Options<CreateCurriculumData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createCurriculum({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCurriculumQueryKey = (options: Options<GetCurriculumData>) => createQueryKey('getCurriculum', options);

export const getCurriculumOptions = (options: Options<GetCurriculumData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCurriculum({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCurriculumQueryKey(options)
    });
};

export const updateCurriculumMutation = (options?: Partial<Options<UpdateCurriculumData>>): UseMutationOptions<UpdateCurriculumResponse, AxiosError<UpdateCurriculumError>, Options<UpdateCurriculumData>> => {
    const mutationOptions: UseMutationOptions<UpdateCurriculumResponse, AxiosError<UpdateCurriculumError>, Options<UpdateCurriculumData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateCurriculum({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publishCurriculumQueryKey = (options: Options<PublishCurriculumData>) => createQueryKey('publishCurriculum', options);

export const publishCurriculumOptions = (options: Options<PublishCurriculumData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await publishCurriculum({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: publishCurriculumQueryKey(options)
    });
};

export const publishCurriculumMutation = (options?: Partial<Options<PublishCurriculumData>>): UseMutationOptions<PublishCurriculumResponse, AxiosError<PublishCurriculumError>, Options<PublishCurriculumData>> => {
    const mutationOptions: UseMutationOptions<PublishCurriculumResponse, AxiosError<PublishCurriculumError>, Options<PublishCurriculumData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await publishCurriculum({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCourseCurriculumAssignmentQueryKey = (options: Options<GetCourseCurriculumAssignmentData>) => createQueryKey('getCourseCurriculumAssignment', options);

export const getCourseCurriculumAssignmentOptions = (options: Options<GetCourseCurriculumAssignmentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCourseCurriculumAssignment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseCurriculumAssignmentQueryKey(options)
    });
};

export const assignCurriculumToCourseMutation = (options?: Partial<Options<AssignCurriculumToCourseData>>): UseMutationOptions<AssignCurriculumToCourseResponse, AxiosError<DefaultError>, Options<AssignCurriculumToCourseData>> => {
    const mutationOptions: UseMutationOptions<AssignCurriculumToCourseResponse, AxiosError<DefaultError>, Options<AssignCurriculumToCourseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await assignCurriculumToCourse({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLearningCourseQueryKey = (options: Options<GetLearningCourseData>) => createQueryKey('getLearningCourse', options);

export const getLearningCourseOptions = (options: Options<GetLearningCourseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLearningCourse({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLearningCourseQueryKey(options)
    });
};

export const updateLearningProgressMutation = (options?: Partial<Options<UpdateLearningProgressData>>): UseMutationOptions<UpdateLearningProgressResponse, AxiosError<DefaultError>, Options<UpdateLearningProgressData>> => {
    const mutationOptions: UseMutationOptions<UpdateLearningProgressResponse, AxiosError<DefaultError>, Options<UpdateLearningProgressData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateLearningProgress({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const submitLearningQuizQueryKey = (options: Options<SubmitLearningQuizData>) => createQueryKey('submitLearningQuiz', options);

export const submitLearningQuizOptions = (options: Options<SubmitLearningQuizData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await submitLearningQuiz({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: submitLearningQuizQueryKey(options)
    });
};

export const submitLearningQuizMutation = (options?: Partial<Options<SubmitLearningQuizData>>): UseMutationOptions<SubmitLearningQuizResponse, AxiosError<DefaultError>, Options<SubmitLearningQuizData>> => {
    const mutationOptions: UseMutationOptions<SubmitLearningQuizResponse, AxiosError<DefaultError>, Options<SubmitLearningQuizData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await submitLearningQuiz({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
